<template>
  <div class="mobileFooterDiv" v-if="mmb">
      <ul>
          <li>
            <router-link :to="gomenu('/qrcode/qrcode-main')">
                <i class="simple-icon-camrecorder"></i>
                <div>QR조회</div>
            </router-link>
          </li>
          <li>
              <router-link :to="gomenu('/coupon/coupon-search')">
                <i class="iconsminds-credit-card"></i>
                <div>쿠폰조회</div>
            </router-link>
          </li>
          <li>
              <router-link :to="gomenu('/booking/booking-request')">
                <i class="simple-icon-calendar"></i>
                <div>예약승인</div>
               </router-link>
          </li>
          <li>
              <router-link :to="gomenu('/booking/booking-visit')">
                <i class="simple-icon-pin"></i>
                <div>방문처리</div>
               </router-link>
          </li>
      </ul>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions,
  mapMutations
} from "vuex";
export default {
data(){
    return{
        mmb: null,
    }
},
computed: {
    ...mapGetters(['currentUser', 'siteName']),
},
created(){
    this.mobilemenu();
},
methods:{
    gomenu(url){
        return "/"+this.siteName+url
    },
    mobilemenu(){
        if(navigator.userAgent.match(/Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)){
            this.mmb = true;
        }else{  
            this.mmb = true;
        }
    }
},
}
</script>

<style>

</style>